import {
	MeshBasicMaterial,
	BoxGeometry,
	Mesh,
	LineBasicMaterial,
	Group
} from 'three';

import drawLine from './drawLine.js';
import drawLabel from './drawLabel.js';
import config from '/lib/config.js';

export default function drawXYZaxesAndLabels( scene ) {

// labels

const labelScale = [ config.axisLabelScale, config.axisLabelScale, config.axisLabelScale ];
const xLabel = drawLabel(
	new URL('/assets/X.svg', import.meta.url).href,
	[ 1.1625, 0, 0 ],
	labelScale
);
scene.add(xLabel);
const yLabel = drawLabel(
	new URL('/assets/Y.svg', import.meta.url).href,
	[ 0, 1.1625, 0 ],
	labelScale
);
scene.add(yLabel);
const zLabel = drawLabel(
	new URL('/assets/Z.svg', import.meta.url).href,
	[ 0, 0, 1.1625 ],
	labelScale
);
const tickScale = [ config.axisTickLabelScale, config.axisTickLabelScale, config.axisTickLabelScale ];
scene.add(zLabel);
const xOne = drawLabel(
	new URL('/assets/1point0.svg', import.meta.url).href,
	[ 1, 0, -0.1 ],
	tickScale
);
scene.add(xOne);
const yOne = drawLabel(
	new URL('/assets/1point0.svg', import.meta.url).href,
	[ 0.06, 1, -0.06 ],
	tickScale
);
scene.add(yOne);
const zOne = drawLabel(
	new URL('/assets/1point0.svg', import.meta.url).href,
	[ -0.1, 0, 1 ],
	tickScale
);
scene.add(zOne);

// axes

const axisMaterial = new MeshBasicMaterial( {color: config.axisColor } ); 

const xAxisGeometry = new BoxGeometry( 1.1, config.axisThickness, config.axisThickness );
const xAxis = new Mesh( xAxisGeometry, axisMaterial ); 
scene.add( xAxis );
xAxis.position.set( 1.1/2, 0, 0 );

const yAxisGeometry = new BoxGeometry( config.axisThickness, 1.1, config.axisThickness );
const yAxis = new Mesh( yAxisGeometry, axisMaterial ); 
scene.add( yAxis );
yAxis.position.set( 0, 1.1/2, 0 );

const zAxisGeometry = new BoxGeometry( config.axisThickness, config.axisThickness, 1.1 );
const zAxis = new Mesh( zAxisGeometry, axisMaterial ); 
scene.add( zAxis );
zAxis.position.set( 0, 0, 1.1/2 );

// ticks

const xOneTickGeometry = new BoxGeometry( config.axisThickness, config.axisThickness, config.tickLength );
const xOneTick = new Mesh( xOneTickGeometry, axisMaterial ); 
xOneTick.position.set( 1, 0, 0 );
scene.add( xOneTick );

const yOneTickGeometry = new BoxGeometry( config.axisThickness, config.axisThickness, config.tickLength );
const yOneTick = new Mesh( yOneTickGeometry, axisMaterial ); 
yOneTick.position.set( 0, 1, 0 );
yOneTick.rotation.set( 0, -45 * ( Math.PI / 180), 0 );
scene.add( yOneTick );

const zOneTickGeometry = new BoxGeometry( config.tickLength, config.axisThickness, config.axisThickness );
const zOneTick = new Mesh( zOneTickGeometry, axisMaterial ); 
zOneTick.position.set( 0, 0, 1 );
scene.add( zOneTick );

// grid / plane

const thinLineMaterial = new LineBasicMaterial( { color: config.thinLineColor } );

const xzPlane = new Group();
scene.add(xzPlane);

xzPlane.add( drawLine( [ [0, 0, 0], [0, 0, 1.1] ], thinLineMaterial ) );
xzPlane.add( drawLine( [ [0.25, 0, 0], [0.25, 0, 1.1] ], thinLineMaterial ) );
xzPlane.add( drawLine( [ [0.5, 0, 0], [0.5, 0, 1.1] ], thinLineMaterial ) );
xzPlane.add( drawLine( [ [0.75, 0, 0], [0.75, 0, 1.1] ], thinLineMaterial ) );
xzPlane.add( drawLine( [ [1, 0, 0], [1, 0, 1.1] ], thinLineMaterial ) );
//xzPlane.add( drawLine( [ [1.1, 0, 0], [1.1, 0, 1.1] ], thinLineMaterial ) );


xzPlane.add( drawLine( [ [0, 0, 0 ], [ 1.1, 0, 0 ] ], thinLineMaterial ) );
xzPlane.add( drawLine( [ [0, 0, 0.25 ], [ 1.1, 0, 0.25 ] ], thinLineMaterial ) );
xzPlane.add( drawLine( [ [0, 0, 0.5 ], [ 1.1, 0, 0.5 ] ], thinLineMaterial ) );
xzPlane.add( drawLine( [ [0, 0, 0.75 ], [ 1.1, 0, 0.75 ] ], thinLineMaterial ) );
xzPlane.add( drawLine( [ [0, 0, 1 ], [ 1.1, 0, 1 ] ], thinLineMaterial ) );
// xzPlane.add( drawLine( [ [0, 0, 1.1 ], [ 1.1, 0, 1.1 ] ], thinLineMaterial ) );

// todo return better stuff...
return xzPlane;


}